/**
 * feature-config flag and dynamic config names owned by `@webflow/code`.
 *
 * The `code-gen` and `code-sync` files predate the team merge and are kept only
 * for the entries already in them; new Code-owned entries belong here.
 */

export const CODE_FLAG_NAMES = {
  AICC_COMPONENT_TEMPLATES: 'ff-ext-2328-aicc-component-templates',
  CODE_FUNCTIONS: 'ff-ext-1203-code-functions',
  CODE_LIBRARY_VARIABLES: 'ff-ext-2645-code-library-variables',
  SOURCE_FILE_GC: 'ff-ext-1962-source-file-gc',
  WORKSPACE_ENV_VARIABLES: 'ff-ext-1195-workspace-env-variables',
  LOCAL_CODE_LIBRARY_DEV: 'ff-ext-2118-local-code-library-dev',
  TRANSFER_CODE_MODULE_ISOLATION: 'ff-ext-2827-transfer-code-module-isolation',
  DISABLE_CODE_MODULE_CLONE_ON_UNINSTALL:
    'ff-ext-3197-disable-code-module-clone-on-uninstall',
} as const;

export const CODE_DYNAMIC_CONFIG_NAMES = {
  FUNCTIONS_SANDBOX_TTL: 'dc-csy-ext-1245-functions-sandbox-ttl',
  CODE_LIBRARY_ARTIFACTS_MIN_CLI_VERSION:
    'dc-ext-1440-artifact-min-cli-version',
} as const;
